import { Row, Col, Card, Button } from "react-bootstrap";
import Leftmenubar from "../Components/Left_menubar";
import BackArrow from "../../../components/backArrow";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RedoIcon from "@mui/icons-material/Redo";
import { useSelector } from "react-redux";
import { useGetUserShopsByBusinessTypeQuery } from "../../../features/shop/shopApiSlice";
import { useGetUserInfoQuery } from "../../../features/user/userApiSlice";
import Nodata from "../../../components/Nodata";
import { getAsset } from "../../../helpers/helper";
import Loader from "../../../components/Loader";
import noImagePlaceholder from "../../../assets/images/dummy/no_image_placeholder.png";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
const RetailerShop = () => {
  const authUser = useSelector((state) => state.auth?.user);
  const persistedUser = useSelector((state) => state.user?.name);
  const currentUser = authUser || persistedUser;
  const userid = currentUser?._id || currentUser?.id || currentUser || "";
  const navigate = useNavigate();
  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);
  const [shareurl, setShareurl] = useState("");

  const { data: retailerResponse, isFetching: isRetailerLoading } =
    useGetUserShopsByBusinessTypeQuery(
      { userid, businessType: "retailerShop" },
      { skip: !userid, refetchOnMountOrArgChange: true },
    );
  const { data: userInfoResponse } = useGetUserInfoQuery(userid, {
    skip: !userid,
  });
  const retailerShop =
    retailerResponse?.data?.data?.Shops ?? retailerResponse?.data?.Shops ?? [];
  const userimg = userInfoResponse?.data?.User?.imageUrl;

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  const resolveShopImage = (shop) => {
    const possibleSources = [shop?.image, shop?.images, shop?.imageUrl];
    const flatten = possibleSources
      .filter(Boolean)
      .flat(Infinity)
      .find((item) => item && String(item).trim());
    return flatten ? getAsset(flatten) : noImagePlaceholder;
  };

  useEffect(() => {
    if (retailerShop.length > 0) {
      localStorage.setItem(
        "mycategory",
        retailerShop[0]?.shopCategory?.name || "",
      );
    }
  }, [retailerShop]);
  return (
    <Row className="business-dashboard-shop-layout">
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        handleClosemodal={handleClosemodal}
        show={show}
        handleShowshare={handleShowshare}
        shareurl={shareurl}
      />
      <Col lg={3} md={3}>
        <Leftmenubar userimg={userimg} />
      </Col>
      <Col
        lg={8}
        md={8}
        className="screenHeight b-radius border_2 ms-lg-3 ms-md-3 col-12 business-dashboard-content"
      >
        <Row className=" justify-content-sm-around justify-content-md-start">
          <Col xl="4" lg="3" md="3" sm="3" xs="6">
            <div className="ms-4 ms-sm-2 ms-md-0 pt-3 pt-sm-4 pb-2 text-sm-center text-md-start">
              <BackArrow back="/SellingSide" mystyle="d-none d-lg-block" />
            </div>
          </Col>
          <Col xl="4" lg="5" md="6" sm="6" xs="6">
            <div className="text-sm-center">
              <h5 className="font-primary mt-4 res-manage-btn">
                Manage Your Shops Here
              </h5>
            </div>
          </Col>
          <Col
            lg="4"
            md="3"
            sm="3"
            xs="5"
            className="text-sm-center text-lg-end text-md-end"
          >
            <div className="mt-4 ps-lg-4 ps-md-4 p-xs-2">
              <Button
                className="createbtt ms-5 ms-sm-0"
                onClick={() => navigate("/retailer-form")}
              >
                Create New{" "}
              </Button>
            </div>
          </Col>
        </Row>
        {isRetailerLoading ? (
          <Loader heightsetting="loaderHeight" />
        ) : (
          <Row className="scroll-shops-business noscroll justify-content-center justify-content-sm-around justify-content-md-start">
            {retailerShop && retailerShop.length > 0 ? (
              retailerShop.map((e) => (
                <Col
                  lg="4"
                  xl="3"
                  md="6"
                  sm="5"
                  xs="11"
                  className="mt-1"
                  key={e?._id || e?.shopname}
                >
                  <Card className="ShopsCards_business ">
                    <div className="fix-img">
                      <img
                        className="c_img"
                        src={resolveShopImage(e)}
                        alt={e?.shopname || "Retailer shop"}
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = noImagePlaceholder;
                        }}
                      />
                    </div>
                    <Card.Body className="p-2">
                      <Card.Title className="font-sm-15 mb-0 pb-1">
                        <div className="d-flex justify-content-between">
                          {e?.shopname?.length >= 7
                            ? e.shopname.substring(0, 7) + `...`
                            : e?.shopname}

                          <button
                            className="text-white bg-blue share_font"
                            onClick={() => {
                              setShareurl(
                                e?.shopUrl || `/rawmaterial-newitem/${e?._id}`,
                              );
                              setShow(1);
                            }}
                          >
                            Share <RedoIcon className="share_icon_f" />
                          </button>
                        </div>
                      </Card.Title>
                      <Card.Text className="font-sm font-primary mb-2">
                        {(() => {
                          const shopAddress = e?.shopaddress || "";
                          return shopAddress.length >= 12
                            ? `${shopAddress.substring(0, 12)}...`
                            : shopAddress;
                        })()}
                      </Card.Text>
                      <button
                        className="viewshop w-100 text-white bg-blue"
                        onClick={() =>
                          navigate(`/rawmaterial-newitem/${e._id}`)
                        }
                      >
                        Manage Your Shop
                      </button>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <div>
                <Nodata />
              </div>
            )}
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default RetailerShop;
